import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import "antd/lib/popover/style";
import _Popover from "antd/lib/popover";
import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/date-picker/style";
import _DatePicker from "antd/lib/date-picker";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /*@通用组件-用于显示数据的头部组件*/
import React from 'react';
import { injectIntl } from "react-intl";
import moment from "moment";
import { connect } from "dva";
import { withRouter } from "react-router-dom";
import './FlowInfo.scss';
import BossTable from '../../../../Common/BossTable';
var Option = _Select.Option;
var RangePicker = _DatePicker.RangePicker;
var FlowInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(FlowInfo, _React$Component);
  function FlowInfo(props) {
    var _this;
    _classCallCheck(this, FlowInfo);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FlowInfo).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "disabledDate", function (current) {
      return current.diff(_this.state.start_tm, 'days') < -5 || current.diff(_this.state.start_tm, 'days') > 6;
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRangeChange", function (moment) {
      if (moment.length === 1) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss")
        });
      } else if (moment.length === 2) {
        _this.setState({
          start_tm: moment[0].format("YYYY-MM-DD HH:mm:ss"),
          end_tm: moment[1].format("YYYY-MM-DD HH:mm:ss")
        }, function () {
          _this.search();
          _this.get_device_flow();
        });
      }
    }); //选择时间间隔
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectTimeInterval", function (type) {
      var start_tm = "";
      var end_tm = moment().format("YYYY-MM-DD HH:mm:ss");
      switch (type) {
        case "0":
          start_tm = moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
          break;
        case "1":
          start_tm = moment().subtract(6, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "2":
          start_tm = moment().subtract(24, 'hours').format("YYYY-MM-DD HH:mm:ss");
          break;
        case "3":
          start_tm = moment().subtract(7, 'days').format("YYYY-MM-DD HH:mm:ss");
          break;
        default:
          start_tm = moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss");
          break;
      }
      _this.setState({
        start_tm: start_tm,
        end_tm: end_tm
      }, function () {
        this.search();
        this.get_device_flow();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (name, e) {
      _this.setState(_defineProperty({}, name, e && e.target ? e.target.value : e));
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "search", function () {
      var params = {
        item: "apprank",
        companyid: _this.state.company_id,
        start_tm: _this.state.start_tm,
        end_tm: _this.state.end_tm,
        top: _this.state.data_num,
        step_sn: _this.state.sn,
        src_ip: _this.state.src_ip,
        dst_ip: _this.state.dst_ip,
        dst_port: _this.state.dst_port
      };
      if (_this.state.tid) {
        params.tid = _this.state.tid;
      }
      _this.props.dispatch({
        type: "ci0302Info/getTableB",
        payload: params
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_device_flow", function () {// let params={
      //     item: "steps",
      //     companyid: this.state.company_id,
      //     start_tm: this.state.start_tm,
      //     end_tm: this.state.end_tm,
      //     top: this.state.top,
      //     sn: this.state.sn,
      // }
      // if(!this.state.tid){
      //     this.props.dispatch({
      //         type: "ci0302Info/get_device_flow",
      //         payload: params
      //     })
      // }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "contentrender", function (record) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: '180px'
        }
      }, /*#__PURE__*/React.createElement(_Row, {
        gutter: 8
      }, /*#__PURE__*/React.createElement(_Col, {
        span: 11
      }, "\u5E94\u7528\u540D\u79F0:"), /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, record.name)), /*#__PURE__*/React.createElement(_Row, {
        gutter: 8
      }, /*#__PURE__*/React.createElement(_Col, {
        span: 11
      }, "\u5E94\u7528\u7C7B\u522B:"), /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, record.app_category_name)), /*#__PURE__*/React.createElement(_Row, {
        gutter: 8
      }, /*#__PURE__*/React.createElement(_Col, {
        span: 11
      }, "\u57DF\u540D/IP:"), /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React.createElement(_Tooltip, {
        title: record.app_dst_ip
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          overflow: 'hidden',
          "text-overflow": 'ellipsis',
          "white-space": "nowrap"
        }
      }, record.app_dst_ip)))), /*#__PURE__*/React.createElement(_Row, {
        gutter: 8
      }, /*#__PURE__*/React.createElement(_Col, {
        span: 11
      }, "\u76EE\u6807\u7AEF\u53E3:"), /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, record.app_dst_port)), /*#__PURE__*/React.createElement(_Row, {
        gutter: 8
      }, /*#__PURE__*/React.createElement(_Col, {
        span: 11
      }, "\u534F   \u8BAE:"), /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, record.app_protocol)));
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "submitAppNameEditB", function (visible, record) {
      if (visible) {
        _this.setState({
          appName: record.name
        });
      } else {
        _this.props.dispatch({
          type: "ci0302Info/update_app_nameB",
          payload: {
            edit: {
              id: record.id,
              name: _this.state.appName
            },
            refresh: {
              item: "apprank",
              companyid: _this.props.companyid,
              start_tm: _this.props.start_tm,
              step_sn: _this.state.selectedStepSn,
              end_tm: _this.props.end_tm,
              top: _this.state.data_num,
              src_ip: _this.state.srcIpB,
              dst_ip: _this.state.desIpB,
              dst_port: _this.state.desPortB
            }
          }
        });
      }
    });
    _this.state = {
      start_tm: _this.props.start_tm ? _this.props.start_tm : moment().subtract(30, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
      end_tm: _this.props.end_tm ? _this.props.end_tm : moment().format("YYYY-MM-DD HH:mm:ss"),
      tunnel_dir: '2',
      top: 5,
      current: '1',
      name: '',
      appFlowListModalVisible: false,
      appFlowListData: {},
      appDetailModalVisible: false,
      //应用流量详情
      detailData: {},
      sn: _this.props.sn,
      company_id: _this.props.company_id,
      src_ip: '',
      dst_ip: '',
      dst_port: '',
      data_num: _this.props.data_num || 5,
      aflow: _this.props.aflow,
      timeIntervalValue: _this.props.timeIntervalValue ? _this.props.timeIntervalValue : '0',
      tid: _this.props.tid
    };
    return _this;
  }
  _createClass(FlowInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.search();
      this.get_device_flow();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      if (this.props.company_id !== nextProps.company_id || this.props.sn !== nextProps.sn) {
        this.setState({
          company_id: nextProps.company_id,
          sn: nextProps.sn
        }, function () {
          _this2.search();
          _this2.get_device_flow();
        });
      }
      if (this.props.aflow !== nextProps.aflow || this.props.sn !== nextProps.sn) {
        this.setState({
          aflow: nextProps.aflow,
          sn: nextProps.sn
        }, function () {
          _this2.search();
          _this2.get_device_flow();
        });
      }
      if (this.props.tid !== nextProps.tid) {
        this.setState({
          tid: nextProps.tid
        }, function () {
          _this2.search();
          _this2.get_device_flow();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var dateFormat = 'YYYY-MM-DD HH:mm:ss';
      var _this$props$ci0302Inf = this.props.ci0302Info.deviceFlowData,
        deviceFlowData = _this$props$ci0302Inf === void 0 ? {} : _this$props$ci0302Inf;
      var _deviceFlowData$flow = deviceFlowData.flow,
        flow = _deviceFlowData$flow === void 0 ? '' : _deviceFlowData$flow;
      var columns = [{
        title: "application program",
        dataIndex: 'name',
        key: 'name',
        width: 150,
        className: "normal",
        render: function render(index, record) {
          var inEnglish = window.appLocale.locale === "en-US";
          return /*#__PURE__*/React.createElement("div", null, record.name !== '未知' ? /*#__PURE__*/React.createElement(_Popover, {
            trigger: "click",
            title: "Application Details",
            style: {
              'width': '200px'
            },
            content: _this3.contentrender(record) // onVisibleChange={(visible) => this.submitAppNameEditB(visible, record)}
          }, /*#__PURE__*/React.createElement("span", {
            style: {
              color: "rgb(24, 144, 255)",
              cursor: 'pointer'
            }
          }, record.name)) : /*#__PURE__*/React.createElement("span", null, record.name === '未知' ? inEnglish ? 'unKnow' : "未知" : record.name));
        }
      }, {
        title: "source address",
        dataIndex: 'src_ip',
        key: 'src_ip',
        className: "normal"
      }, {
        title: "Destination Address",
        dataIndex: 'dst_ip',
        key: 'dst_ip',
        className: "normal"
      }, {
        title: "Target Port",
        dataIndex: 'dst_port',
        key: 'dst_port',
        className: "normal"
      }, {
        title: "Traffic (MB)",
        dataIndex: 'flow',
        key: 'flow',
        className: "normal",
        render: function render(text) {
          return /*#__PURE__*/React.createElement("span", null, (text / 1024 / 1024).toFixed(2));
        }
      }, {
        title: "agreement",
        dataIndex: 'protocol',
        key: 'protocol',
        className: "normal"
      }, {
        title: "Proportion of traffic (%)",
        dataIndex: 'p',
        key: 'p',
        render: function render(text, record) {
          return /*#__PURE__*/React.createElement("div", null, (Number(record.flow) / Number(flow) * 100).toFixed(2));
        }
      }];
      return /*#__PURE__*/React.createElement("div", {
        className: "FlowInfo"
      }, /*#__PURE__*/React.createElement("header", {
        className: "clearfix"
      }, /*#__PURE__*/React.createElement("div", null, !this.props.noTimeChange ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select a time interval",
        style: {
          width: 120,
          marginRight: 8
        },
        className: "input",
        onChange: this.selectTimeInterval,
        defaultValue: this.state.timeIntervalValue
      }, /*#__PURE__*/React.createElement(Option, {
        value: "0",
        key: "0"
      }, "Last 30 minutes"), /*#__PURE__*/React.createElement(Option, {
        value: "1",
        key: "1"
      }, "Last 6 hours"), /*#__PURE__*/React.createElement(Option, {
        value: "2",
        key: "2"
      }, "Last Day"), /*#__PURE__*/React.createElement(Option, {
        value: "3",
        key: "3"
      }, "Last week")), /*#__PURE__*/React.createElement(RangePicker, {
        style: {
          width: 330,
          marginRight: 8
        },
        showTime: true,
        value: [moment(this.state.start_tm, dateFormat), moment(this.state.end_tm, dateFormat)],
        disabledDate: this.disabledDate,
        onCalendarChange: this.handleRangeChange
      })) : "", /*#__PURE__*/React.createElement(_Select, {
        placeholder: "Please select the number of data entries",
        style: {
          width: 80,
          marginRight: 8
        },
        className: "input",
        onChange: function onChange(e) {
          return _this3.handleChange('data_num', e);
        },
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "5 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "10 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "15 articles"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "20 articles")), /*#__PURE__*/React.createElement(_Input, {
        style: {
          width: 120,
          marginRight: 8
        },
        placeholder: "Please enter the source address",
        onChange: function onChange(e) {
          return _this3.handleChange('src_ip', e);
        }
      }), /*#__PURE__*/React.createElement(_Input, {
        style: {
          width: 120,
          marginRight: 8
        },
        placeholder: "Please enter the destination address",
        onChange: function onChange(e) {
          return _this3.handleChange('dst_ip', e);
        }
      }), /*#__PURE__*/React.createElement(_Input, {
        style: {
          width: 120,
          marginRight: 8
        },
        placeholder: "Please enter the destination port",
        onChange: function onChange(e) {
          return _this3.handleChange('dst_port', e);
        }
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.search,
        icon: "search"
      }, "search"))), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '10px 0'
        }
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: 18,
          marginRight: 10
        }
      }, "Total flow rate:", this.props.noTimeChange ? this.state.aflow : Number(flow / 1024 / 1024).toFixed(2), "MB")), /*#__PURE__*/React.createElement(BossTable, {
        dataSource: this.props.ci0302Info.dataSourceB,
        columns: columns
      }));
    }
  }]);
  return FlowInfo;
}(React.Component); // FlowInfo.propTypes = {
// };
// export default injectIntl(FlowInfo);
function mapDispatchToProps(_ref) {
  var ci0302Info = _ref.ci0302Info;
  return {
    ci0302Info: ci0302Info
  };
}
export default connect(mapDispatchToProps)(withRouter(injectIntl(FlowInfo)));